import { PathResolver } from "../../Controls/withResolvePaths";
import { ViewModelSelect } from "../../Helpers/StateAccessors/ViewModelSelect";
import { ModelActionType } from "../Core/ModelStoring/Store/modelActions";
import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";
import { CalculationAwaitingOption, IForm } from "../Form/IForm";
import {
    AbsoluteModelPath,
    AbsoluteResolvedModelPath,
    convertToAbsoluteModelPath,
} from "../../../../Common/ModelPath/ModelPath";

export function validateModalFormAction(
    verifiablePaths: AbsoluteModelPath[],
    parentViewModelSelect: ViewModelSelect,
    doNotValidateFormOnStart: boolean,
    resolvePath: PathResolver
): CandyThunkAction<Promise<string | undefined>> {
    return async (_, getState, form: IForm) => {
        const viewModelSelect = parentViewModelSelect.withNextViewModel();
        const getControlPaths = (paths: AbsoluteModelPath[]) =>
            paths
                .map(path => form.resolveMask(resolvePath(path).toLegacyPath()))
                .filter(getUniqItems)
                .flat();

        const controlPaths = getControlPaths(verifiablePaths);

        if (doNotValidateFormOnStart) {
            await form.revalidatePaths(controlPaths.map(convertToAbsoluteModelPath));
        }

        await form.waitForPendingCalculations(CalculationAwaitingOption.CalculationsAndValidations);

        const firstErrorPath = controlPaths.find(path =>
            Boolean(viewModelSelect.controlModel(getState(), path)?.error)
        );
        return firstErrorPath;
    };
}

export const redefineModel: CandyThunkAction = (dispatch, _, form) => {
    form.changeSet.redefine();
    dispatch({ type: ModelActionType.redefineModel });
};

export const mergeRedefinedModel: CandyThunkAction = (dispatch, _, form) => {
    form.changeSet.mergeRedefined();
    dispatch({ type: ModelActionType.MergeRedefinedModel });
    form.filteringManager.handleRedefinedModelMerged();
};

export const dropRedefinedModel: CandyThunkAction = (dispatch, _, form) => {
    form.changeSet.dropRedefined();
    dispatch({ type: ModelActionType.DropRedefinedModel });
};

export const removeModelFields: (path: AbsoluteResolvedModelPath) => CandyThunkAction =
    path => (dispatch, __, form) => {
        form.removeByPrefix(path);
        form.normalizeByPrefix(path);
        dispatch(mergeRedefinedModel);
    };

const getUniqItems = <T>(value: T, index: number, arr: T[]) => arr.indexOf(value) === index;
